
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
import { Heading } from '@/components/Heading'
import { TipGood, TipBad } from '@/components/Tip'
import { CodeSample } from '@/components/CodeSample'
const Layout = _Layout;
const meta = {
  "id": "location",
  "title": "Geo Location",
  "sidebar_label": "Location & Map"
};
const slug = 'location';
const tableOfContents = [{
  "title": "Accounts",
  "slug": "accounts",
  "children": []
}, {
  "title": "Maps supported",
  "slug": "maps-supported",
  "children": []
}, {
  "title": "Places currently available",
  "slug": "places-currently-available",
  "children": []
}, {
  "title": "Scenarios",
  "slug": "scenarios",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">







    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#ead61278-02a3-4447-b6ce-14642dd9f853"
      }}>{`API REFERENCE`}</a></p>
    <p>{`Users are able to add location information in various contexts to enhance the buying and selling experiences.`}</p>
    <_Heading level={2} id={"accounts"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Accounts</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Accounts are able to add locations while creating the account. This helps when buyers find nearby accounts (on collection widget).`}</li>
      <li parentName="ul">{`Accounts are able to add location while adding listings/products (they can opt to remove as well), so their items show up in listing search.`}</li>
    </ul>
    <div class="flex flex-wrap gap-5">
  <div class="relative w-1/2 md:w-1/3 my-4">
    <img class="w-full h-100 object-cover rounded-lg shadow-lg" src="https://media.tradly.app/images/marketplace/73395/Searchbymap1-bVeZDeWY.png" />
  </div>
  <div class="relative w-1/3 my-4">
    <img class="w-full h-100 object-cover rounded-lg shadow-lg" src="https://media.tradly.app/images/marketplace/39460/Searchbymap-GuPEtzOl.png" />
  </div>
    </div>
    <p>{`There are few ways you can configure them to achieve your business`}</p>
    <_Heading level={2} id={"maps-supported"} nextElement={{
      "type": "list",
      "ordered": true,
      "start": 1,
      "spread": false
    }}>Maps supported</_Heading>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Google Maps (Places API)`}</li>
      <li parentName="ol">{`Openstreet map`}</li>
      <li parentName="ol">{`iOS native apple maps`}</li>
    </ol>
    <_Heading level={2} id={"places-currently-available"} nextElement={{
      "type": "list",
      "ordered": true,
      "start": 1,
      "spread": false
    }}>Places currently available</_Heading>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Account creation (Example: Store creation)`}</li>
      <li parentName="ol">{`Listing creation (Example: Product or a property having a location field)`}</li>
      <li parentName="ol">{`Address (shipping address, pickup address)`}</li>
    </ol>
    <_Heading level={2} id={"scenarios"} nextElement={{
      "type": "list",
      "ordered": true,
      "start": 1,
      "spread": false
    }}>Scenarios</_Heading>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Finding nearby accounts through search with KM or Miles filters`}</li>
      <li parentName="ol">{`Creating collection widgets using nearby location (you can configure whether you want around 15KM or # number)`}</li>
      <li parentName="ol">{`Buyers are able to find the location of a listing on the listing detail page`}</li>
      <li parentName="ol">{`Anyone is able to find the location of an account/store profile on their about us page (if the marketplace owner has made the location field public)`}</li>
      <li parentName="ol">{`Buyers or Account owners are able to find the location in order detail page (delivery address or pickup address)`}</li>
    </ol>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
